import { useRestaurant } from '../context/useRestaurant';
import { ContactInfo } from '../components/contactInfo/ContactInfo';
import { GuestNotes } from '../components/guestNotes/GuestNotes';
import { GuestTags } from '../components/guestTags/GuestTags';
import { HotelGuestProfile } from '../components/hotelGuestProfile/HotelGuestProfile';
import { GuestVipTier } from '../components/guestVipTier/GuestVipTier';
import type { GuestsApiGuest } from './apiHelpers';

export const GuestProfile = ({ guest }: { guest: GuestsApiGuest }) => {
  const { hotelIntegrationEnabled } = useRestaurant();

  return (
    <>
      <ContactInfo phone={guest.phone} email={guest.email} />
      {/* Above the tags, mirroring the occupant drawer's order (HotelLinkSection then GuestTags):
          Opera's allergies and Peak's own allergy tags sit next to each other, never merged. */}
      {hotelIntegrationEnabled && <HotelGuestProfile guestId={guest.id} />}
      <GuestTags guestId={guest.id} />
      <GuestVipTier guestId={guest.id} />
      <GuestNotes guestId={guest.id} />
    </>
  );
};
